<div class="smartbar-contents">
  <div [ngClass]="['container-fluid mb-0', containerClasses]">
    <div class="row">
      <ng-content></ng-content>
    </div>
  </div>
</div>
